import { Link } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';
import { EmptyState } from '@/components';
import Can from '@rbac/Can';

/**
 * "Pick what you sell first" (MERCH-85 P1c, ADR 0009 §1): there is no default product
 * type, so a store that has not chosen any can add no models, units or imports. Shown
 * where those start; it points to Settings → What you sell.
 */
export default function NoProductTypes({ compact }) {
  return (
    <EmptyState
      compact={compact}
      title="Choose what your store sells"
      action={<Can module="inventory" action="update"><Link to="/settings?tab=catalogue"><Button>Choose product types</Button></Link></Can>}
    >
      Your store does not sell any product types yet. Pick them under Settings → What you sell, then add models and stock.
    </EmptyState>
  );
}

/** True once the store's types have loaded and none is on (pure, for tests). */
export const noTypesChosen = (storeTypes) => Array.isArray(storeTypes) && !storeTypes.some((t) => t.enabled);
